import { render, staticRenderFns } from "./CapturePaymentRequest.vue?vue&type=template&id=894ba8aa&scoped=true"
import script from "./CapturePaymentRequest.vue?vue&type=script&lang=js"
export * from "./CapturePaymentRequest.vue?vue&type=script&lang=js"
import "./CapturePaymentRequest.vue?vue&type=style&index=0&id=894ba8aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894ba8aa",
  null
  
)

export default component.exports